import React from 'react';
import { Link } from 'react-router-dom';

import smallLogo from '../Images/logo_only.png';
import logo from '../Images/dataco_black_text_small.png';

function Logo() {
    return (
        <span className="mt-3 mx-3">
            <Link to="/">
                {/* TODO: conditionally load images and lazy load */}
                <span className="d-none d-md-block">
                    <img
                        alt="DataCo Logo"
                        src={logo}
                        id="logo"
                        style={{ height: '3rem' }}
                    />
                </span>
                <span className="d-md-none">
                    <img
                        alt="Simple DataCo Logo"
                        src={smallLogo}
                        id="logo"
                        style={{ height: '2.5rem' }}
                    />
                </span>
            </Link>
            &emsp;
        </span>
    );
}

export default Logo;
